<template>
  <div class="email-preview-modal">
    <HMModalHeader
      :title="$t('MARKETING.TITLES.EMAIL_PREVIEW')"
      @close="$emit('close')"
    />
    <div class="w-100">
      <iframe
        class="content"
        :srcdoc="content"
        frameBorder="0"
        height="100%"
        width="100%"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { HMModalHeader } from '@/web/components/common';

export default {
  name: 'EmailPreviewModal',
  components: {
    HMModalHeader,
  },
  props: {
    content: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.content {
  min-height: 500px;
}
</style>
